<template>
    <div class="bonus-animation" :class="bonusShow ? 'bonus-show': ''" >
        <RotateCoin v-for="(ca, i) in coinsArray" v-bind:key="i" :coinx="ca.x" :coiny="ca.y" :coinScale="ca.scale" ></RotateCoin>
        <RotateDinero v-for="(ca, i) in chipsArray" v-bind:key="'chip' + i" :dinerox="ca.x" :dineroy="ca.y" :dineroScale="ca.scale" ></RotateDinero>
    </div>
</template>

<script>
import RotateCoin from './RotateCoin.vue';
import RotateDinero from './RotateDinero.vue';
import utils from '../../utils/utils.js';
export default {
    props: {
        from: Object,
        to: Object
    },
    data() {
        return {
            bonusShow: false,
            coinsArray: [],
            chipsArray: []
        }
    },
    methods: {
        show() { this.bonusShow = true },
        hide() { this.bonusShow = false },
        startAnimation(showCoins = false, showChips = false, from, to, onComplete) {
            let coinDistance = { x: to.coins.x - from.x, y: to.coins.y - from.y },
                chipsDistance = { x: to.chips.x - from.x, y: to.chips.y - from.y },
                record = 0;

            utils.animation(3000, 0, 200, (_cur) => {
                // console.log(_cur)
                _cur = Math.floor(_cur);
                if (_cur >= record * 5) {
                    record++;
                    if (this.coinsArray.length > 1) {
                        for (let i = this.coinsArray.length - 1; i >= 1; i--) {
                            let data = JSON.parse(JSON.stringify(this.coinsArray[i - 1]));
                            data.scale = this.coinsArray[i].scale;
                            this.coinsArray[i] = data;
                        }
                    }
                    if (this.chipsArray.length > 1) {
                        for (let j = this.chipsArray.length - 1; j >= 1; j--) {
                            let data = JSON.parse(JSON.stringify(this.chipsArray[j - 1]));
                            data.scale = this.chipsArray[j].scale;
                            this.chipsArray[j] = data;
                        }
                    }

                    if (_cur < 100) {
                        let percent = _cur / 100, pow = Math.pow(percent, 3);
                        showCoins && this.coinsArray[0] && (this.coinsArray[0] = {
                            x: from.x + percent * coinDistance.x,
                            y: from.y + pow * coinDistance.y,
                            scale: this.coinsArray[0].scale,
                        })
                        showChips && this.chipsArray[0] && (this.chipsArray[0] = {
                            x: from.x + percent * chipsDistance.x,
                            y: from.y + pow * chipsDistance.y,
                            scale: this.chipsArray[0].scale
                        })

                        showCoins && this.coinsArray.push({ x: from.x, y: from.y, scale: 0.2 + Math.random() * 0.3 });
                        showChips && this.chipsArray.push({ x: from.x, y: from.y, scale: 0.3 + Math.random() * 0.2 })
                    } else {
                        this.coinsArray.shift();
                        this.chipsArray.shift();
                    }
                }
            }, () => {
                this.coinsArray = [];
                this.chipsArray = [];
                onComplete && onComplete();
                this.hide();
            })
        }
    },
    components: { RotateCoin, RotateDinero }
}
</script>

<style lang="scss" >
.bonus-animation {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    display: none;
}

.bonus-show {
    display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/animations/BonusAnimation.vue